import type { DreamNode } from "@gtm/contracts/core/dream-list";

/** Center managers over their reports; leave room for each card and its controls. */
export function arrangeOrgChart(nodes: DreamNode[]): DreamNode[] {
  const children = new Map<string | null, DreamNode[]>();
  for (const node of nodes) {
    const siblings = children.get(node.reportsTo) ?? [];
    siblings.push(node);
    children.set(node.reportsTo, siblings);
  }
  let column = 0;
  const positions = new Map<string, { x: number; y: number }>();
  function place(node: DreamNode, depth: number): number {
    const reports = children.get(node.id) ?? [];
    const xs = reports.map((report) => place(report, depth + 1));
    const x = xs.length ? (xs[0]! + xs[xs.length - 1]!) / 2 : column++ * 320;
    positions.set(node.id, { x, y: depth * 240 });
    return x;
  }
  for (const root of children.get(null) ?? []) place(root, 0);
  return nodes.map((node) => ({ ...node, ...positions.get(node.id) }));
}
